import { forwardRef, useEffect, useImperativeHandle, useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import ProductListItemDTO from "@common/dtos/ProductListItemDTO";
import OpMachineDTO from "@common/dtos/OpMachineDTO";
import { StandardBoxItem } from "./StandardBoxItem";
import StandardBoxDTO from "@common/dtos/boxes/StandardBox";
import { StandardBoxViewer } from "./StandardBoxViewer";
import { PrizeBoxItem } from "./PrizeBoxItem";
import PrizeBoxDTO from "@common/dtos/boxes/PrizeBox";
import { PrizeBoxViewer } from "./PrizeBoxViewer";

export interface BoxesListHandle {
    closeBoxes: () => void;
}

export interface BoxesListProps {
    machine: OpMachineDTO;
    apiURI: string;
    products: ProductListItemDTO[];
    canEditProduct: boolean;
    canEditPrice: boolean;
    canEditQnty: boolean;
}

export const BoxesList = forwardRef<BoxesListHandle, BoxesListProps>((props, ref) => {
    const { t } = useTranslation();
    const [selectedStandardBoxNr, setSelectedStandardBoxNr] = useState<number|null>(null);
    const [selectedStandardBox, setSelectedStandardBox] = useState<StandardBoxDTO|null>(null);
    const [selectedPrizeBoxNr, setSelectedPrizeBoxNr] = useState<number|null>(null);
    const [selectedPrizeBox, setSelectedPrizeBox] = useState<PrizeBoxDTO|null>(null);

    useEffect(() => {
        setSelectedStandardBox(Object.values(props.machine.boxes).find(box => box.nr == selectedStandardBoxNr) ?? null);
    }, [selectedStandardBoxNr, props.machine]);

    useEffect(() => {
        setSelectedPrizeBox(Object.values(props.machine.prizes).find(box => box.id == selectedPrizeBoxNr) ?? null);
    }, [selectedPrizeBoxNr, props.machine]);

    const length = useMemo(() => Object.keys(props.machine.boxes).length, [props.machine]);

    useImperativeHandle(ref, () => ({
        closeBoxes(){
            setSelectedStandardBoxNr(-1);
            setSelectedPrizeBoxNr(-1);
        }
    }));

    if (length === 0) return <span className="text-muted fst-italic w-100 text-center">{t('no_boxes')}</span>;

    return (
        <section className="d-flex w-100 row m-0 overflow-auto h-100">
            { selectedStandardBox && <>
                <StandardBoxViewer
                    {...props}
                    box={selectedStandardBox}
                    onClose={() => setSelectedStandardBoxNr(null)}
                />
            </> }
            { selectedPrizeBox && <>
                <PrizeBoxViewer
                    {...props}
                    box={selectedPrizeBox}
                    onClose={() => setSelectedPrizeBoxNr(null)}
                />
            </> }
            { (!selectedStandardBox && !selectedPrizeBox) &&
                <div className="d-flex flex-column">
                    <div className="d-inline-block pb-3">
                        {Object.values(props.machine.boxes).map(box =>
                            <StandardBoxItem
                                key={box.nr}
                                box={box}
                                onSelect={() => {
                                    setSelectedPrizeBoxNr(null);
                                    setSelectedStandardBoxNr(box.nr);
                                }}
                            />
                        )}
                    </div>
                    {Object.keys(props.machine.prizes).length > 0 && <>
                        <div className="d-inline-block pb-3">
                            {Object.values(props.machine.prizes).map(box =>
                                <PrizeBoxItem
                                    key={box.id}
                                    box={box}
                                    onSelect={() => {
                                        setSelectedStandardBoxNr(null);
                                        setSelectedPrizeBoxNr(box.id);
                                    }}
                                />
                            )}
                        </div>
                    </>}
                </div>
                
                
            }
        </section>
    );
});